import React from "react";

const DoubleChatStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.157 6.24358C14.0156 6.91178 14.1868 7.778 14.1868 9.17821C14.1868 10.2114 13.8897 11.0358 13.389 11.6655C13.2074 11.8939 13.2457 12.4263 13.3908 12.6762C13.7382 13.2743 13.0819 13.9296 12.3685 13.7777C11.8346 13.6642 11.2745 13.5104 10.7843 13.3041C10.6049 13.2286 10.4067 13.1981 10.2109 13.2187C9.96774 13.2442 9.71951 13.2569 9.46816 13.2569C8.19381 13.2569 7.32152 13.3258 6.45348 12.64M6.21042 10.2872C8.55506 10.2872 10.6074 9.03232 10.6074 6.24358C10.6074 3.45487 8.55506 2.19995 6.21042 2.19995C3.8658 2.19995 1.81348 3.45487 1.81348 6.24358C1.81348 7.26788 2.09035 8.08522 2.55688 8.70949C2.72612 8.93595 2.69046 9.46377 2.55521 9.71153C2.23154 10.3045 2.84309 10.9542 3.5078 10.8036C4.00536 10.691 4.52726 10.5386 4.98399 10.3341C5.1512 10.2592 5.33583 10.229 5.51827 10.2494C5.7449 10.2747 5.9762 10.2872 6.21042 10.2872Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(DoubleChatStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;